export default {
  MEDIA_CONTAINER_TAG: 'ws-media-container',
  BACKGROUND_CONTAINER_TAG: 'ws-background-container',
  GALLERY_ITEM_TAG: 'ws-media-container[origin-src]',
  BLOCK_WITH_BACKGROUND_TAG: 'ws-block[background-image]',
};
